import axios from 'axios'
import router from '@/router'
import store from '@/store/store'
import utils from './utils'
import { Message } from 'element-ui'

// axios.defaults.baseURL = 'https://test.edu.yuejike.com'// 测试
axios.defaults.baseURL = 'https://management.twinkletalk.com.cn' // 正式
axios.interceptors.request.use(config => {
  // 每次请求后台的时候，如果有token，需要请求头携带token。
  config.headers.Authorization = `Bearer ${store.getUser().access_token || utils.getCookie('pc_token')}`
  // config.headers.lan='zh_CN'
  return config
}, err => Promise.reject(err))
axios.interceptors.response.use(res => {
  if (res.data.code === 10001) {
    router.push('/')
    utils.clearCookie('pc_token')
  }else
  if(res.data.code == 200){
    return res
  }else
  {
    console.log(res.data);
    Message({
      message: res.data.msg,
      type: 'error'
    })
  }

}, err => {
  // 根据当前的响应状态码是不是401去跳转登录页面

  // 状态码  err.response.status 就是
  if (err.response.status === 401) {
    router.push('/')
  }
  return Promise.reject(err)
})
export default axios



// WEBPACK FOOTER //
// ./src/utils/request.js